/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import Slider from 'react-slick';

// styled components
import VendorPartnerLogosStyles from './styles/vendor-partner-logos-styles';

// slick css files
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const VendorPartnerLogos = () => {
    const settings = {
        autoplay: true,
        autoplaySpeed: 0,
        dots: false,
        infinite: true,
        pauseOnHover: true,
        slidesToScroll: 1,
        slidesToShow: 6,
        useTransform: false,
        speed: 2000,
        cssEase: 'linear',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    dots: false,
                    infinite: true,
                    slidesToScroll: 1,
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 2,
                },
            },
        ],
    };

    const data = useStaticQuery(graphql`
        query {
            peoplelinx: file(relativePath: { eq: "peoplelinx-logo.png" }) {
                ...fluidImage
            }
            pizzaAgents: file(relativePath: { eq: "pizza-agents-logo.png" }) {
                ...fluidImage
            }
            jpmParts: file(relativePath: { eq: "jpm-parts-logo.png" }) {
                ...fluidImage
            }
            proliant: file(relativePath: { eq: "proliant-logo.jpg" }) {
                ...fluidImage
            }
            rockbot: file(relativePath: { eq: "rockbot-logo.png" }) {
                ...fluidImage
            }
            restaurant365: file(
                relativePath: { eq: "restaurant_365_logo.png" }
            ) {
                ...fluidImage
            }
            boa: file(relativePath: { eq: "bank-of-america-logo.png" }) {
                ...fluidImage
            }
            pepsi: file(relativePath: { eq: "Pepsi-logo.jpg" }) {
                ...fluidImage
            }
            WS: file(relativePath: { eq: "WSLogo.png" }) {
                ...fluidImage
            }
            FDC: file(relativePath: { eq: "FDC.jpg" }) {
                ...fluidImage
            }
            irhCap: file(relativePath: { eq: "irh-Logo.jpg" }) {
                ...fluidImage
            }
            elevanta: file(relativePath: { eq: "elevanta.png" }) {
                ...fluidImage
            }
            xlt: file(relativePath: { eq: "xlt.png" }) {
                ...fluidImage
            }
            workwizard: file(relativePath: { eq: "workwizard-logo.png" }) {
                ...fluidImage
            }
            prepwizard: file(relativePath: { eq: "prepwizard_logo.jpg" }) {
                ...fluidImage
            }
            zari: file(relativePath: { eq: "zari-logo.png" }) {
                ...fluidImage
            }
            intwine: file(relativePath: { eq: "intwine-logo.png" }) {
                ...fluidImage
            }
            stAndrews: file(relativePath: { eq: "st-andrews-logo.png" }) {
                ...fluidImage
            }
            northernPizza: file(relativePath: { eq: "northern-pizza.jpg" }) {
                ...fluidImage
            }
            decisely: file(relativePath: { eq: "decisely-logo.png" }) {
                ...fluidImage
            }
            paymasters: file(relativePath: { eq: "paymasters.png" }) {
                ...fluidImage
            }
            lutherLanard: file(relativePath: { eq: "LutherLanard-logo.png" }) {
                ...fluidImage
            }
            franchiseLoansDirect: file(
                relativePath: { eq: "franchise-loans-direct-logo.png" }
            ) {
                ...fluidImage
            }
            dailyPay: file(relativePath: { eq: "dailypay-logo.jpeg" }) {
                ...fluidImage
            }
            tcp: file(relativePath: { eq: "tcp-logo.png" }) {
                ...fluidImage
            }
            savi: file(relativePath: { eq: "savi_logo.png" }) {
                ...fluidImage
            }
            franbiz: file(relativePath: { eq: "franbiz_logo.png" }) {
                ...fluidImage
            }
        }
    `);

    const styles = {
        img: {
            objectFit: 'contain',
            objectPosition: 'center',
        },
    };

    // add new vendor logos here into to 3rd position of the slider

    return (
        <VendorPartnerLogosStyles>
            <h1>Our Vendor Partners</h1>
            <Slider {...settings}>
                <div className="Logo__container">
                    <a
                        href="https://www.restaurant365.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Img
                            imgStyle={styles.img}
                            fluid={data.restaurant365.childImageSharp.fluid}
                        />
                    </a>
                </div>
                <div className="Logo__container">
                    <a
                        href="https://franchiseelawyer.com"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Img
                            imgStyle={styles.img}
                            fluid={data.lutherLanard.childImageSharp.fluid}
                        />
                    </a>
                </div>
                <div className="Logo__container">
                    <a
                        href="https://peoplelinx.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Img
                            alt="PeopleLinx"
                            imgStyle={styles.img}
                            fluid={data.peoplelinx.childImageSharp.fluid}
                        />
                    </a>
                </div>
                <div className="Logo__container">
                    <a
                        href="https://www.workwizard.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Img
                            alt="WorkWizard"
                            imgStyle={styles.img}
                            fluid={data.workwizard.childImageSharp.fluid}
                        />
                    </a>
                </div>
                <div className="Logo__container">
                    <a
                        href="https://www.dailypay.com/industries/franchise/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Img
                            imgStyle={styles.img}
                            fluid={data.dailyPay.childImageSharp.fluid}
                        />
                    </a>
                </div>
                <div className="Logo__container">
                    <a
                        href="https://www.franchiseloansdirect.com"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Img
                            imgStyle={styles.img}
                            fluid={
                                data.franchiseLoansDirect.childImageSharp.fluid
                            }
                        />
                    </a>
                </div>
                <div className="Logo__container">
                    <a
                        href="https://tcpsoftware.com?utm_source=event&utm_medium=events&utm_campaign=___26q2_lce"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Img
                            imgStyle={styles.img}
                            fluid={data.tcp.childImageSharp.fluid}
                        />
                    </a>
                </div>
                <div className="Logo__container">
                    <a
                        href="https://getsavi.com"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Img
                            imgStyle={styles.img}
                            fluid={data.savi.childImageSharp.fluid}
                        />
                    </a>
                </div>
                <div className="Logo__container">
                    <a
                        href="https://www.franbiznetwork.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Img
                            imgStyle={styles.img}
                            fluid={data.franbiz.childImageSharp.fluid}
                        />
                    </a>
                </div>
                <div className="Logo__container">
                    <a
                        href="https://www.littlecaesarsstore.com"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Img
                            imgStyle={styles.img}
                            fluid={data.stAndrews.childImageSharp.fluid}
                        />
                    </a>
                </div>
                <div className="Logo__container">
                    <a
                        href="https://www.intwineconnect.com"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Img
                            imgStyle={styles.img}
                            fluid={data.intwine.childImageSharp.fluid}
                        />
                    </a>
                </div>
                <div className="Logo__container">
                    <a
                        href="https://www.zarifinancials.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Img
                            imgStyle={styles.img}
                            fluid={data.zari.childImageSharp.fluid}
                        />
                    </a>
                </div>
                <div className="Logo__container">
                    <a
                        href="https://www.pizzaagents.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Img
                            imgStyle={styles.img}
                            fluid={data.pizzaAgents.childImageSharp.fluid}
                        />
                    </a>
                </div>
                <div className="Logo__container">
                    <a
                        href="https://www.vcmparts.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Img
                            imgStyle={styles.img}
                            fluid={data.jpmParts.childImageSharp.fluid}
                        />
                    </a>
                </div>
                <div className="Logo__container">
                    <a
                        href="https://www.proliant.com"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Img
                            imgStyle={styles.img}
                            fluid={data.proliant.childImageSharp.fluid}
                        />
                    </a>
                </div>
                <div className="Logo__container">
                    <a
                        href="https://www.rockbot.com/littlecaesars"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Img
                            imgStyle={styles.img}
                            fluid={data.rockbot.childImageSharp.fluid}
                        />
                    </a>
                </div>
                <div className="Logo__container">
                    <a
                        href="https://bankofamerica.com/GeneralFranchise"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Img
                            imgStyle={styles.img}
                            fluid={data.boa.childImageSharp.fluid}
                        />
                    </a>
                </div>
                <div className="Logo__container">
                    <a
                        href="https://www.pepsico.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Img
                            imgStyle={styles.img}
                            fluid={data.pepsi.childImageSharp.fluid}
                        />
                    </a>
                </div>
                <div className="Logo__container">
                    <a
                        href="https://prep-wizard.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Img
                            imgStyle={styles.img}
                            fluid={data.prepwizard.childImageSharp.fluid}
                        />
                    </a>
                </div>
                <div className="Logo__container">
                    <a
                        href="https://www.irhcapital.com/littlecaesars"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Img
                            imgStyle={styles.img}
                            fluid={data.irhCap.childImageSharp.fluid}
                        />
                    </a>
                </div>
                <div className="Logo__container">
                    <a
                        href="http://www.xltovens.com/IOLCF"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Img
                            imgStyle={styles.img}
                            fluid={data.xlt.childImageSharp.fluid}
                        />
                    </a>
                </div>
                <div className="Logo__container">
                    <a
                        href="http://www.elevantahealth.com/iolcf"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Img
                            imgStyle={styles.img}
                            fluid={data.elevanta.childImageSharp.fluid}
                        />
                    </a>
                </div>
                <div className="Logo__container">
                    <a
                        href="https://northernpizzaequipment.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Img
                            imgStyle={styles.img}
                            fluid={data.northernPizza.childImageSharp.fluid}
                        />
                    </a>
                </div>
                <div className="Logo__container">
                    <a
                        href="https://lcbenefits.decisely.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Img
                            imgStyle={styles.img}
                            fluid={data.decisely.childImageSharp.fluid}
                        />
                    </a>
                </div>
                <div className="Logo__container">
                    <a
                        href="https://www.paymastersinc.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Img
                            imgStyle={styles.img}
                            fluid={data.paymasters.childImageSharp.fluid}
                        />
                    </a>
                </div>
            </Slider>
        </VendorPartnerLogosStyles>
    );
};

export default VendorPartnerLogos;

export const fluidImage = graphql`
    fragment fluidImage on File {
        childImageSharp {
            fluid(maxWidth: 300) {
                ...GatsbyImageSharpFluid
            }
        }
    }
`;
